import en from './trans/en';
import de from './trans/de';
import fr from './trans/fr';
import it from './trans/it';
import nl from './trans/nl';
import es from './trans/es';
import pt from './trans/pt';

export const fallbackLocale = 'en';

export default {
    en,
    de,
    fr,
    it,
    nl,
    es,
    pt
};